import React from 'react';
import { Row, Col, Clearfix, Label } from 'react-bootstrap';
import { get as _get, camelCase as _camelCase } from 'lodash';

import { getThumbFile, getThumbFileFromEntity } from 'helpers/items';
import { getColorForString } from 'helpers/charts';
import { getTextColor } from 'components/forms/autocomplete/Color';

import RoundImage from 'components/layout/RoundImage';
import NestedLevelButton from 'pages/Account/Clients/NestedLevelButton';

const propGetter = (obj, path) => {
  if (!obj) return '';

  return (
    _get(obj, path) ??
    path.split('.').reduce((acc, prop) => {
      const getterName = _camelCase(`get_${prop}`); // first_name => getFirstName
      return acc && acc[getterName] ? acc[getterName]() : null;
    }, obj) ??
    ''
  );
};

class ClientListInfo extends React.Component {
  render() {
    const { client, showAddress, internalNote } = this.props;

    const company = propGetter(client, 'profile.company');
    const firstName = propGetter(client, 'profile.first_name');
    const lastName = propGetter(client, 'profile.last_name');
    const street = propGetter(client, 'profile.street');
    const houseNumber = propGetter(client, 'profile.house_number');
    const apartmentNumber = propGetter(client, 'profile.apartment_number');
    const addressLine2 = propGetter(client, 'profile.address_line2');
    const zipCode = propGetter(client, 'profile.zip_code');
    const city = propGetter(client, 'profile.city');

    const email = propGetter(client, 'profile.email');
    const phone = propGetter(client, 'profile.phone');
    const mobile = propGetter(client, 'profile.mobile');

    let avatarThumbLink = null;
    if (_get(client, 'profile.avatar')) {
      const imageThumb = getThumbFile(client.profile.avatar);
      avatarThumbLink = imageThumb ? imageThumb.web_link : null;
    } else if (client && client.getProfile) {
      const imageThumb = getThumbFileFromEntity(client.getProfile().getAvatar());
      avatarThumbLink = imageThumb ? imageThumb.getWebLink() : null;
    }

    const avatarColor = '#' + getColorForString(firstName + lastName);
    const avatarTextColor = getTextColor(avatarColor);

    return (
      <Row>
        <Col xs={9} md={showAddress ? 5 : 10} className="no-padding relative">
          <div className="top-left">
            {avatarThumbLink ? (
              <RoundImage size={50} usePixels url={avatarThumbLink} />
            ) : (
              <div style={{ opacity: '.6' }}>
                <RoundImage size={50} usePixels hexColor={avatarColor}>
                  <h6 style={{ color: avatarTextColor }} className="bold">
                    {firstName.substring(0, 1)}&nbsp;{lastName.substring(0, 1)}
                  </h6>
                </RoundImage>
              </div>
            )}
          </div>

          <Clearfix>
            <div className="pull-left p-t-60" />
            <div className="m-l-65 p-t-5 pull-left">
              <strong>
                {!!company && (
                  <>
                    {company}
                    <br />
                  </>
                )}
                {firstName} {lastName}
              </strong>
            </div>
          </Clearfix>
        </Col>

        <Col xs={3} md={2} className="p-l-10 p-r-10 sm-p-r-0">
          <div>
            <Label bsStyle={client?.user_role_set === 'Standard' ? 'success' : 'primary'}>
              {client?.user_role_set}
            </Label>
          </div>

          <NestedLevelButton username={client?.username} children_count={client?.children_count} />
        </Col>

        {showAddress && (
          <Col xs={12} md={5} className="p-l-10 p-r-0 sm-p-l-0">
            <div>
              <i className="fa fa-fw fa-map-marker" /> {street} {houseNumber} {apartmentNumber} {addressLine2},{' '}
              {zipCode} {city}
            </div>
            {!!email && (
              <div>
                <i className="fa fa-fw fa-envelope" /> {email}
              </div>
            )}
            {!!phone && (
              <div>
                <i className="fa fa-fw fa-phone" /> {phone}
              </div>
            )}
            {!!mobile && (
              <div>
                <i className="fa fa-fw fa-mobile-android" /> {mobile}
              </div>
            )}
          </Col>
        )}
        <Col>{internalNote}</Col>
      </Row>
    );
  }
}
ClientListInfo.defaultProps = {
  showAddress: true,
};

export default ClientListInfo;
